export class PhysicalState {
  static UNDEFINED = -1;
  static SICK = 0;
  static TIRED = 1;
  static ACTIVE = 2;
  static VERY_ACTIVE = 3;
}
